export const iconFontAwesomeUsersPeopleBaby = (
	<i className="fa-solid fa-baby"></i>
);
